@if (visible$()) {
  <sol-debug-info />
}
